import { render } from "./detail.vue?vue&type=template&id=4bf567ab&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=4bf567ab&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf567ab"],['__file',"src/views/ticket/order/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bf567ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bf567ab', __exports__)) {
    console.log('reload')
    api.reload('4bf567ab', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=4bf567ab&scoped=true", () => {
    console.log('re-render')
    api.rerender('4bf567ab', render)
  })

}


export default __exports__